import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CustomerCaptain } from 'anchor-shared/lib/model/interface/customerInterfaces';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  Discount,
  PromoCodeResponse,
  PromoType,
  PromoWithTotalDiscount,
} from 'anchor-shared/lib/model/entity/discount';
import { Subject, Subscription } from 'rxjs';
import { DiscountDAO } from '../../../../../core/services/dao/discountDAO';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-admin-promo-code',
  templateUrl: './admin-promo-code.component.html',
  styleUrls: ['./admin-promo-code.component.scss'],
})
export class AdminPromoCodeComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  affiliateId: number = null;

  promoCode: PromoWithTotalDiscount;
  lastEmittedPromo: string;
  latestCouponId: number;
  boatCaptCrewTotal: number;
  discountTotal: number = 0;
  promoCodeSuccess: Subject<Discount> = new Subject<PromoCodeResponse>();

  subs: Subscription[] = [];

  constructor(
    public discountDao: DiscountDAO,
    public dialogRef: MatDialogRef<AdminPromoCodeComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.promoCode = this.data.promoCode;
    this.boatCaptCrewTotal = this.data.boatCaptCrewTotal;
    this.affiliateId = this.data.affiliateId;
  }

  ngOnInit(): void {
    sessionStorage.removeItem('promo');
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  keepPromo() {
    this.dialogRef.close();
  }

  removePromo() {
    this.dialogRef.close({
      removePromo: true,
    });
  }

  applyPromoCode(promo: string): void {
    this.lastEmittedPromo = promo;
    if (promo) {
      const sub = this.discountDao
        .validatePromoCode(promo, PromoType.CHARTER)
        .subscribe((promoResponse) => {
          if (promoResponse) {
            this.latestCouponId = promoResponse.discountId;
            this.promoCodeSuccess.next(promoResponse);

            if (promoResponse.percentageBased) {
              this.discountTotal =
                (promoResponse.amount / 100) * this.boatCaptCrewTotal;
            } else {
              this.discountTotal = promoResponse.amount;
            }

            if (promoResponse.discountId) {
              this.dialogRef.close({
                promoResponse: promoResponse,
                discountTotal: this.discountTotal,
              });
            }
          }
        });
      this.subs.push(sub);
    }
  }
}
